<template>
  <div class="home">
    <div class="carousel-contain">
      <v-carousel class="carousel d-none d-sm-block" cycle height="660px" hide-delimiters :show-arrows="false">
        <v-carousel-item
            v-for="(item,i) in lists"
            :key="i"
            :src="item.image"
        ></v-carousel-item>
      </v-carousel>

      <v-carousel class="d-block d-sm-none" cycle height="285px" hide-delimiters :show-arrows="false">
        <v-carousel-item
            v-for="(item,i) in lists"
            :key="i"
            :src="item.image"
        ></v-carousel-item>
      </v-carousel>
      <div class="txt-contain d-none d-sm-block">
        <h2>
          {{ $t("carousel1") }}
        </h2>
        <h2>
          {{ $t("carousel2") }}
        </h2>
        <h5>
          {{ $t("carousel3") }}
        </h5>
      </div>
    </div>
    <div class="d-none d-sm-block">
      <div class="divider mb-2"></div>
      <SearchCar @search="getCar" v-model="form"></SearchCar>
      <CarList :list="carList"/>
      
      <div class="mx-5 mx-sm-12">
<!--        <RecommandCar></RecommandCar>-->
        <UserGuide></UserGuide>

        <NewsList></NewsList>
      </div>
    </div>

    <div class=" d-block d-sm-none">
      <div class="divider mb-2"></div>
      <div class="mx-sm-12">
<!--        <RecommandCar></RecommandCar>-->
        <SearchCar @search="getCar" v-model="form"></SearchCar>
        <div style="margin-top:30px"><CarList :list="carList"/></div>
        <div class="mx-5"><UserGuide></UserGuide></div>
        <NewsList></NewsList>
      </div>
    </div>


  </div>
</template>

<script>
// @ is an alias to /src
import CarList from '@/components/CarList.vue'
import SearchCar from '@/components/SearchCar.vue'
// import RecommandCar from '@/components/RecommandCar.vue'
import NewsList from '@/components/NewsList.vue'
import UserGuide from '@/components/UserGuide.vue'
// import ShowCalender from '@/components/ShowCalender.vue'

export default {
  name: 'home-view',
  data: () => ({
    form: {
      search_str: '',
      brand_id: '',
      pageNumber:0,
      pageSize:9999,
    },
    model: '',
    colors: '',
    lists: [],
    carList: [],
  }),
  components: {
    CarList,
    SearchCar,
    // RecommandCar,
    UserGuide,
    NewsList,
    // ShowCalender,
  },
  watch: {
    "form.brand_id": function () {
      this.getCar()
    },
    pickerDate(val) {
      console.log(val)
      this.$router.push({path:'/searchcar',query:{time:val}});
    },
  },
  methods: {
    getCar() {
      this.$api.fetch('/product/searchList', {
        ...this.form,
        brand_id: this.form.brand_id + ''
      }).then((res) => {
        console.log(res)
        this.carList = res.list
      })
    },
    functionEvents(date) {
      if (this.disableData.includes(date)) {
        return ['#ff0000']
      }
      return true
    },
  },
  mounted() {
    this.$api.fetch('/home/getGoodsList', { // 获取首页轮播
      "resultType": "poster1",//产品类型（非必传）  news新产品倒叙    poster1 广告位商品  poster2 首页广告位
      // "brandId": 1,//品牌ID（非必传）
      // "categoryId": 2,//标签ID(非必传)   -1表示查询没有标签的车辆
      "pageNumber": 1,//当前页
      "pageSize": 10//每页数量
    }).then((res) => {
      this.lists = res.list
    })
    this.getCar()
  }
}
</script>
<style scoped lang="scss">
.carousel-contain {
  position: relative;
}

.carousel {
  border-radius: 0 0 50px 50px;
  background-color: black;
}
.txt-contain{
  position: absolute;
  z-index: 9;
  top:160px;
  left:5.4vw;
  color: #FFFFFF;
  h2{
    font-size: 55px;
  }
}

.divider {
  height: 9vw;
  max-height: 255px;
}

.home {
  position: relative;

  .datepicker-pc {
    position: absolute;
    top: 380px;
    left: 5vw;
    z-index: 1;
    border-radius: 20px;
    overflow: hidden;
    opacity: 0.9;
  }
}

</style>
<style lang="scss">
.datepicker {
  height: 18vw;
  min-height: 210px;
  max-height: 380px;
  max-width: 380px;

  .v-picker__body {
    height: 18vw;
    min-height: 210px;
    max-height: 380px;
    max-width: 380px;
  }

  .v-picker__title {
    display: none;
  }

  .v-date-picker-header {
    display: none;
  }

  .theme--light.v-btn:focus::before {
    display: none;
  }

  .theme--light.v-btn:hover:before {
    display: none;
  }

  .green--text {
    background: #caece0;
    border-radius: 8px;
    border-color: transparent;
  }

  .v-btn--disabled {
    background: #f1f1f1;
    border-radius: 8px;
    border-color: transparent;
  }

  .v-date-picker-table__events {
    bottom: -14px !important;
  }

  .v-date-picker-table__events > div {
    width: 4px;
    height: 4px;
  }

  div {
    height: 100%;
  }

  table {
    height: 100%;
  }
}

.v-image__image--cover {
  background-position: 50% 70% !important;
}

</style>
